import { IGCSToken, IStorageExternal } from "./storage-external";
import { IShardRepositoryRaw } from "../../api/entities/shard-repository";

export class StorageGCS implements IStorageExternal {
    getToken(storageNode: IShardRepositoryRaw): IGCSToken {
        return JSON.parse(storageNode.props);
    }
}
